import {
  Banknote,
  Clock,
  CreditCard,
  Heart,
  Leaf,
  Phone,
  Shield,
  Star,
  Store,
  Truck,
  type LucideIcon,
} from "lucide-react";
import { cn } from "@/utils/cn";
import {
  TRUST_BADGE_LABELS,
  type StorefrontTrust,
  type TrustBadgeKind,
} from "@/lib/storefront-trust";

const BADGE_ICONS: Record<TrustBadgeKind, LucideIcon> = {
  CASH_ON_DELIVERY: Banknote,
  ENZONA: CreditCard,
  STORE_PICKUP: Store,
  HOME_DELIVERY: Truck,
};

// Slice 11b — lista cerrada del panel (TRUST_BADGE_ICONS en la API).
const CUSTOM_ICONS: Record<string, LucideIcon> = {
  truck: Truck,
  store: Store,
  shield: Shield,
  clock: Clock,
  phone: Phone,
  leaf: Leaf,
  star: Star,
  heart: Heart,
};

/**
 * Slice 11 — sellos de confianza. Solo los que vienen de la config real del
 * negocio (`trust.autoBadges` + `trust.customBadges`); sin sellos, no renderiza.
 */
export default function TrustBadges({
  trust,
  className,
}: {
  trust: StorefrontTrust | undefined;
  className?: string;
}) {
  if (!trust) return null;
  const items = [
    ...trust.autoBadges.map((kind) => ({
      key: kind,
      label: TRUST_BADGE_LABELS[kind],
      Icon: BADGE_ICONS[kind] as LucideIcon | undefined,
    })),
    ...trust.customBadges.map((b, i) => ({
      key: `custom-${i}`,
      label: b.label,
      Icon: CUSTOM_ICONS[b.icon] as LucideIcon | undefined,
    })),
  ];
  if (items.length === 0) return null;

  return (
    <ul className={cn("flex flex-wrap gap-2 text-[11px] opacity-80", className)}>
      {items.map(({ key, label, Icon }) => (
        <li
          key={key}
          className="inline-flex items-center gap-1 rounded-lg border border-[rgb(var(--border-rgb))] px-2 py-1 bg-[rgb(var(--card-2-rgb))]"
        >
          {Icon ? <Icon size={12} aria-hidden="true" /> : null}
          {label}
        </li>
      ))}
    </ul>
  );
}
